import {cx} from "emotion";
import * as React from "react";

import "./future-editions.scss";

import {getCartTotalPurchaseAmount}   from "@Common/logic/cart/get-cart-total-purchase-amount";
import {to_getFriendlyName}           from "@Common/logic/template-options/template-options-get-friendly-name";
import {to_imgToSmall}                from "@Common/logic/template-options/template-options-image-to-small";
import {to_imgToUltra}                from "@Common/logic/template-options/template-options-image-to-ultra";
import {cs}                           from "@Common/react/chain-services";
import {consumeContext}               from "@Common/react/context";
import {keyed}                        from "@Common/react/keyed";
import {Load}                         from "@Common/react/load";
import {Load2}                        from "@Common/react/load2";
import {ModuleSwamp}                  from "@Common/react/module-swamp/module-swamp";
import {UseState}                     from "@Common/react/use-state";
import {cnv}                          from "@Common/utils/arr-path";
import {sort, toGroupsByKey}          from "@Common/utils/collections";
import {addDate, le, today, toJsDate} from "@Common/utils/date-object";
import {parseDateFormat}              from "@Common/utils/date/parse-date-format";
import {chain}                        from "@Common/utils/fs";
import {values}                       from "@Common/utils/objects";

import {ScDistributionModules1} from "../../../steps/distribution/modules/sc-distribution-modules";

import {EditionCard}        from "./edition-card";
import {OptoutEditionModal} from "./optout-edition-modal/optout-edition-modal";

// TODO: Sometimes no img, sometimes, img will show message that says: Need more time to proof
export const FutureEditions = (
    {
        getStyleTemplate, enrollment, editions2, className,
        saveEnrollment, program,
    }
) => cs(
    ["hide", (_, next) => UseState({next})],
    ({hide}) => (
        <div className={cx("future-editions-4jd", className)}>
            <div className="header">
                <div className="line1">
                    <div {...{
                        className: "title",

                        "xd-qa-type": "label",
                        "xd-qa-name": "Future Editions",
                    }}>
                        Future Editions
                    </div>

                    {!!editions2?.length && (
                        <a {...{
                            onClick: () => hide.change(v=>!v),
                            "xd-qa-type": "link",
                            "xd-qa-name": (
                                hide.value ? (
                                    "Future Editions - Show Details"
                                ) : (
                                    "Future Editions - Hide Details"
                                )
                            ),
                        }}>
                            {hide.value ? (
                                "Show Details"
                            ) : (
                                "Hide Details"
                            )}
                        </a>
                    )}
                </div>

                <div {...{
                    className: "subtitle",

                    "xd-qa-type": "label",
                    "xd-qa-name": "Future Editions Description",
                }}>
                    Each Edition will be mailed/shipped within 5 business days after the Final Day to Edit period.{" "}
                    Order will be processed and charged on the fulfillment date
                </div>
            </div>


            {!hide.value && cs(
                ["editions", ({}, next) => chain(
                    editions2,
                    (_) => sort(_, ({pe}) => chain(
                        pe,
                        (pe) => pe && df2.parseDate(pe.orderReviewDeadline),
                        (date) => !date ? null : toJsDate(date).getTime(),
                    )),
                    (_) => next(_),
                )],
                ["showAll", (_, next) => UseState({next})],
                ({showAll, editions}, next) => (
                    <div className="box">
                        {next()}

                        {editions?.length > 2 && !showAll.value && (
                            <div {...{
                                className: "show-more",

                                "xd-qa-type": "link",
                                "xd-qa-name": "Show All Editions",
                            }}>
                                <a
                                    onClick={() => showAll.onChange(true)}
                                >
                                    Show All Editions ({editions.length})
                                </a>
                            </div>
                        )}
                    </div>
                ),
                ["editions", ({editions, showAll}, next) => next(showAll.value || !(editions?.length > 2) ? editions : editions.slice(0,2))],

                ({editions}, next) => !editions?.length ? (
                    <div {...{
                        className: "no-data",

                        "xd-qa-type": "label",
                        "xd-qa-name": "No data",
                    }}>
                        No data
                    </div>
                ) : (
                    next()
                ),

                consumeContext("apis"),
                ["editions", ({editions}, next) => {
                    const groups = toGroupsByKey(editions, ({pe}) => pe.seriesId);
                    return sort(Object.keys(groups), (seriesId) => toJsDate(df2.parseDate(groups[seriesId][0].pe.enrollmentDeadline)).getTime())
                        .map((seriesId) => cs(
                            keyed(seriesId),
                            ["series", (_, next) => next(program.programPreferences.series.find((s) => s.id === seriesId))],
                            ({series}) => (
                                <div className="series" key={seriesId}>

                                    <div {...{
                                        className: "title",

                                        "xd-qa-type": "label",
                                        "xd-qa-name": series.name + " Series",
                                    }}>
                                        {series.name} Series
                                    </div>

                                    {next(groups[seriesId])}

                                </div>
                            ),
                        ))
                        ;
                }],
                ["optoutEditionModal", (_, next) => OptoutEditionModal({next})],

                consumeContext("templateOptionsCache"),
                ["estimateTotal", ({editions, templateOptionsCache}, next) => cs(
                    ["templateOptions", ({}, next) => {
                        const pe = editions[0]?.pe;
                        return templateOptionsCache.load({
                            key: !pe?.templateId ? null : {
                                front: +pe.templateId,
                                back: +pe.templateId,
                            },
                            next,
                        });
                    }],
                    ["modules", ({templateOptions}, next) => ModuleSwamp({
                        moduleFeeds: ScDistributionModules1({
                            initEnrollment: enrollment,
                            templateOptions: templateOptions.value, // This is default templateOptions,
                            // since the "getEstimatedTotal" may need a default templateOptions for detailed calculation
                        }),
                        next,
                    })],
                    ({modules}) => next((templateOptions) => modules.getModule("getEstimatedTotal")(templateOptions)),
                )],
                ({editions, apis, optoutEditionModal, templateOptionsCache, estimateTotal}) => (
                    editions?.map(({ue, pe, run}) => cs(
                        keyed((ue ?? pe ?? run).editionId),

                        ["series", (_, next) => next(program.programPreferences.series.find((s) => s.id === pe.seriesId))],
                        ["templateOptions", ({}, next) => templateOptionsCache.load({
                            key: !pe?.templateId ? null : {
                                front: +pe.templateId,
                                back : +pe.templateId,
                            },
                            next,
                        })],
                        ["template", ({}, next) => next(getStyleTemplate(pe?.templateId))],
                        ["price", ({templateOptions}, next) => (
                            run?.idCart ? cs(
                                ["cart", ({}, next) => Load2({
                                    fetch: () => apis.next.cart.getCart(run.idCart),
                                    next,
                                })],

                                ({cart}) => next(
                                    cart.loading ? {
                                        loading: true,
                                    } : !run?.idCart ? {
                                        value: null,
                                    } : !cart.value?.items?.length ? {
                                        error: true,
                                    } : {
                                        value: getCartTotalPurchaseAmount(cart.value),
                                    }
                                ),
                            ) : (
                                next({
                                    value: estimateTotal(templateOptions.value)
                                })
                            )
                        )],
                        ["item", ({}, next) => Load({
                            disabled: !run,
                            fetch: () => apis.next.item.getItem(run.idOrder),
                            next,
                        })],
                        ({price, template, item, templateOptions, series}) => EditionCard({
                            templateId: pe?.templateId,
                            imgs: (
                                !run ? (
                                    values(template?.images ?? {}).map(({url}) => ({
                                        thumbnail: to_imgToSmall(url),
                                        enlarged : to_imgToUltra(url),
                                    }))
                                ) : (
                                    (
                                        item?.metaData?.ccReferenceURLs?.jpg
                                            .map((url) => ({enlarged: url}))
                                    ) ?? [{loading: true}]
                                )
                            ),
                            amount: (
                                price.loading ? {
                                    loading: true,
                                } : price.value == null ? (
                                    null
                                ) : {
                                    tooltip: "Pricing is estimated and may vary due to changes in postage rates, tax, or enrollment selections",
                                    value: price.value,
                                }
                            ),

                            // name: "August, 2023",
                            name: !pe ? "" : pe.name + ", " + series.name,
                            templateName: to_getFriendlyName(templateOptions.value) ?? templateOptions.value?.product?.name,

                            ...!pe ? ({
                                errorMessage: "ERROR: No program edition",
                                badge: {
                                    color: "danger",
                                    icon: "fa fa-exclamation-triangle",
                                    message: "ERROR",
                                },
                            }) : run ? (
                                price.loading ? (
                                    null
                                ) : price.error || run.current_state === "ORDER_ERROR" ? {
                                    // errorMessage: run.current_state_info,
                                    errorMessage: "Order Failed - Please Contact Support",
                                    badge: {
                                        color: "danger",
                                        icon: "fa fa-exclamation-triangle",
                                        message: "Order Error",
                                    },
                                } : run.current_state === "ORDER_READY" ? {
                                    proofLink: "/customize/order/" + run.idOrder,
                                    badge: {
                                        color: "green",
                                        // icon: "fa fa-exclamation-triangle",
                                        message: "Ready for Review",
                                    },
                                } : run.current_state === "PENDING_USER_UPDATE" ? {
                                    errorMessage: run.current_state_info,
                                    badge: {
                                        color: "danger",
                                        icon: "fa fa-exclamation-triangle",
                                        message: "Needs Attention",
                                    },
                                } : run.current_state === "PENDING_AUTO_RETRY" ? {
                                    errorMessage: run.current_state_info,
                                    badge: {
                                        color: "danger",
                                        icon: "fa fa-exclamation-triangle",
                                        message: "Checkout Failed",
                                    },
                                } : run.current_state === "START" && {
                                    badge: {
                                        color: "default",
                                        message: "In progress",
                                    },
                                }
                            ) : ue && le(today(), df2.parseDate(pe.enrollmentDeadline)) && !series.forceAutoEnroll && {
                                deleting: {
                                    confirm: async () => await optoutEditionModal.show({pe}),
                                    onDelete: async () => {
                                        await saveEnrollment(cnv(enrollment, ["editionsPreferences"], (_) => _.filter((ue1) => ue1.editionId !== ue.editionId)));
                                    },
                                },
                            },

                            details: !pe ? [] : [
                                run ? {
                                    label: "Review Deadline",
                                    value: chain(
                                        df2.parseDate(pe.orderReviewDeadline),
                                        (_) => df1.formatDate(_),
                                    ),
                                } : {
                                    label: "Available for Review",
                                    value: chain(
                                        df2.parseDate(pe.enrollmentDeadline),
                                        (_) => addDate(_, 1),
                                        (_) => df1.formatDate(_),
                                    ),
                                },
                                {
                                    label: "Fulfillment Begins",
                                    value: chain(
                                        df2.parseDate(pe.orderReviewDeadline),
                                        (_) => addDate(_, 1),
                                        (_) => df1.formatDate(_),
                                    ),
                                    tooltip: "This is the date that the order will begin production",
                                },
                            ],
                        }),
                    ))
                ),
            )}
        </div>
    )
);

const df1 = parseDateFormat("MMMM dd, yyyy");
const df2 = parseDateFormat("yyyy-mm-dd");

